// import styles
import styles from "./whitesquare.module.scss";

// import interfaces
import WhiteSquareProps from "@/interfaces/WhiteSquare";

// import utils
import {
  handleSquarePosition,
  handleSquareVisibility,
} from "@/utils/WhiteSquare";

export default function WhiteSquare({
  isAlternative = false,
  isLighter = false,
  isHidden = false,
  isVisibleOnMobile = true,
  position = "bottom-left",
  isDefaultColor = true,
}: WhiteSquareProps) {
  return (
    <>
      <div
        className={`${styles._default} ${
          isDefaultColor ? "" : styles._alternative_color
        } ${
          position !== "bottom-left" ? styles._alternative_size : ""
        } ${handleSquarePosition(position, styles)} ${
          isAlternative ? styles._alternative : ""
        } ${isLighter ? styles._light : ""} ${handleSquareVisibility(
          isVisibleOnMobile,
          isHidden,
          styles
        )}`}
      ></div>
      <div
        className={`${styles._default} ${
          isDefaultColor ? "" : styles._alternative_color
        } ${
          position !== "bottom-left" ? styles._alternative_size : ""
        } ${handleSquarePosition(position, styles)} ${
          isAlternative ? styles._alternative : ""
        } ${isLighter ? styles._light : ""} ${handleSquareVisibility(
          isVisibleOnMobile,
          isHidden,
          styles
        )} `}
      ></div>
    </>
  );
}
